import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import CreateNewRequest from '../../../../createNewRequest/createNewRequest';
import LoanTemplateDetail from './LoanTemplateDetail';
import LoanTemplateList from './LoanTemplateList';

const LoanTemplateContainer = ({ setStep, setTabChild }: { setStep: any, setTabChild: any }) => {
    const [innerState, setInnerState] = useState<'selectLoanTemplate' | 'confirmLoanTemplate' | 'createNewRequest'>('selectLoanTemplate');
    const [key, setKey] = useState<string>('');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextState);
    const stateFromBack = useSelector((state: RootState) => state.prevAndNextState.nextInnerState);
    const queryClient = useQueryClient()
    const currentState = {
        'selectLoanTemplate': <LoanTemplateList setInnerState={setInnerState} setKey={setKey} />,
        'confirmLoanTemplate': <LoanTemplateDetail setInnerState={setInnerState} setTabChild={setTabChild} loanTemplateKey={key ? key : queryClient.getQueryData('LOAN_TEMPLATE_KEY')!} />,
        'createNewRequest': <CreateNewRequest setStep={setStep} loanTemplateKey={key ? key : queryClient.getQueryData('LOAN_TEMPLATE_KEY')} />,
    }
    useEffect(() => {
        if (stateFromBack.includes('confirmLoanTemplate')) setInnerState('confirmLoanTemplate')
        else if (stateFromBack.includes('selectLoanTemplate')) setInnerState('selectLoanTemplate')
        else if (stateFromBack.includes('createNewRequest')) setInnerState('createNewRequest')
    }, [stateFromBack])

    useEffect(() => {
        if (stateFromRedux.includes('confirmLoanTemplate')) setInnerState('confirmLoanTemplate')
        else if (stateFromRedux.includes('selectLoanTemplate')) setInnerState('selectLoanTemplate')
        else if (stateFromRedux.includes('createNewRequest')) setInnerState('createNewRequest')
    }, [stateFromRedux])
    return (
        <div>
            {currentState[innerState!]}
        </div>
    )
}

export default LoanTemplateContainer
